import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { PROXY_HISTORY_TOOL_NAME } from './portal-tool.constants';

export { PROXY_HISTORY_TOOL_NAME };

export const ProxyHistoryActionSchema = z.enum(['list', 'get']);

export const ProxyHistoryInputSchema = z.object({
  action: ProxyHistoryActionSchema,
  requestId: z.string().optional(),
  skip: z.int().min(0).default(0),
  limit: z.int().min(1).max(50).default(20),
  host: z.string().optional(),
  method: z.string().optional(),
  statusCode: z.number().optional(),
  statusMin: z.number().optional(),
  statusMax: z.number().optional(),
  search: z.string().optional(),
  sources: z.array(z.string()).optional(),
  excludeProxyModified: z
    .boolean()
    .optional()
    .describe(
      'List only: when true, omit proxy-modified rows from list results. No effect on get. Not a default — set true for endpoint-creation history search. Such rows cannot be tracked even if returned via get.',
    ),
});

export const ProxyHistoryHeadersSchema = z.record(z.string(), z.string());

export const ProxyHistoryRowSchema = z.object({
  id: z.string(),
  method: z.string(),
  url: z.string(),
  statusCode: z.number().nullable(),
  statusMessage: z.string().nullable(),
  timestamp: z.number(),
  durationMs: z.number().nullable(),
  requestBodyPreview: z.string().nullable(),
  responseBodyPreview: z.string().nullable(),
  source: z.string().nullable(),
  wasIntercepted: z.boolean(),
  wasProxyModified: z.boolean(),
  requestHeaders: ProxyHistoryHeadersSchema.optional(),
  responseHeaders: ProxyHistoryHeadersSchema.optional(),
  requestBody: z.string().optional(),
  responseBody: z.string().optional(),
});

export const ProxyHistoryDataSchema = z.object({
  rows: z.array(ProxyHistoryRowSchema),
  total: z.number(),
  skip: z.number(),
  limit: z.number(),
});

export const ProxyHistoryOutputSchema = createPortalToolOutputSchema({
  dataSchema: ProxyHistoryDataSchema,
});

export type ProxyHistoryInput = z.infer<typeof ProxyHistoryInputSchema>;
export type ProxyHistoryOutput = z.infer<typeof ProxyHistoryOutputSchema>;
export type ProxyHistoryRow = z.infer<typeof ProxyHistoryRowSchema>;
export type ProxyHistoryData = z.infer<typeof ProxyHistoryDataSchema>;
